import React, { useEffect, useState } from "react";
import VehiclePartsAdd from "./VehiclePartsAdd";
import { useLocation, useParams } from "react-router-dom";
import {
  PartInventoryImageDetails,
  getPartInventoryDetails,
} from "../../services/PartsInventory";

const AddParts = () => {
  const { uuid } = useParams();
  const location = useLocation();
  const [vehicleAddDetails, setvehicleAddDetails] = useState("");
  const [vehicleImageDetails, setvehicleImageDetails] = useState([]);
  const [vehicleAddDetailsLoader, setvehicleAddDetailsLoader] = useState(false);

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        setvehicleAddDetailsLoader(true);
        getPartInventoryDetails(obj)
          .then((response) => {
            response = response.data.data;
            setvehicleAddDetails(response);
            setvehicleAddDetailsLoader(false);
          })
          .catch((err) => {
            setvehicleAddDetailsLoader(false);
          });
      } else if (location.state?.item) {
        // Entrada via "Desmantelar Carro" do /vehicle-process: usa o item do
        // estado como fonte directa do veículo seleccionado (sem chamada ao
        // endpoint /part-inventory-details, que é para peças já existentes).
        setvehicleAddDetails(location.state.item);
      }
    },

    [uuid, location.state]
  );

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        PartInventoryImageDetails(obj)
          .then((response) => {
            response = response.data.data;
            setvehicleImageDetails(response);
          })
          .catch((err) => {});
      }
    },

    [uuid]
  );

  return (
    <>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item"></li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <VehiclePartsAdd
              vehicleAddDetails={vehicleAddDetails}
              vehicleImageDetails={vehicleImageDetails}
              setvehicleImageDetails={setvehicleImageDetails}
              vehicleAddDetailsLoader={vehicleAddDetailsLoader}
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default AddParts;
